var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrackUparrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8838 0.392324C5.62653 0.135053 5.20941 0.135053 4.95214 0.392324L0.759664 4.5848C0.502393 4.84207 0.502393 5.25919 0.759664 5.51646C1.01693 5.77373 1.43405 5.77373 1.69132 5.51646L5.41797 1.78982L9.14461 5.51646C9.40188 5.77373 9.819 5.77373 10.0763 5.51646C10.3335 5.25919 10.3335 4.84207 10.0763 4.5848L5.8838 0.392324ZM5.41797 0.858154L4.75918 0.858154L4.75918 14.0338L5.41797 14.0338L6.07675 14.0338L6.07675 0.858154L5.41797 0.858154Z",
    fill: "url(#paint0_linear_109_501)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_501",
    x1: 5.41797,
    y1: 7.44599,
    x2: 4.41797,
    y2: 7.44599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA657"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrackUparrow);
export default __webpack_public_path__ + "static/media/crack-uparrow.4710cb4f3fd5a1fb297bc9766d413f67.svg";
export { ForwardRef as ReactComponent };